import type { IntakeFormField } from '../../api/bookingApi';

export interface BirthdayParts {
  month: string;
  day: string;
  year: string;
}

export function isBirthdayField(field: IntakeFormField): boolean {
  return field.field_type === 'date' && (field.ehr_mapping === 'date_of_birth'
    || field.key === 'date_of_birth' || field.key.split('_').includes('dob'));
}

export function birthdayPartsFromISO(value: unknown): BirthdayParts {
  const match = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
  return match ? { month: match[2], day: match[3], year: match[1] } : { month: '', day: '', year: '' };
}

type BirthdayResult = { status: 'empty' | 'partial' | 'invalid' | 'future' } | { status: 'valid'; iso: string };

/** Calendar validation without Date rollover, UTC conversion or year-0–99 coercion. */
export function parseBirthday(parts: BirthdayParts, localToday: string): BirthdayResult {
  const { month, day, year } = parts;
  if (!month && !day && !year) return { status: 'empty' };
  if (!month || !day || !year) return { status: 'partial' };
  if (!/^\d{1,2}$/.test(month) || !/^\d{1,2}$/.test(day) || !/^\d{4}$/.test(year)) return { status: 'invalid' };
  const m = Number(month), d = Number(day), y = Number(year);
  if (y < 1 || m < 1 || m > 12) return { status: 'invalid' };
  const leap = y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (d < 1 || d > days[m - 1]) return { status: 'invalid' };
  const iso = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  return iso > localToday ? { status: 'future' } : { status: 'valid', iso };
}
